import React from 'react';
import {getAcceptedServiceOrders} from "../../../services/serviceOrdersService";
import OrderStack from "../OrderStack";


function AcceptedServiceOrders() {
    const dataToUpdate = ['warehouse', 'user', 'document_type', 'category', 'contractor', 'contractor_name',
        'email', 'phone_number', 'device', 'priority', 'acceptance_date', 'closing_date', 'description', 'stage'];
    const enabled_actions = ['synchronize'];
    return (
        <OrderStack getData={getAcceptedServiceOrders}
                    tableTitle={'Zaakceptowane zlecenia serwisowe'}
                    disabled={false}
                    dataToUpdate={dataToUpdate}
                    enabled_actions={enabled_actions}
        />
    );
}

export default AcceptedServiceOrders;